var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1953,
    cy: 12.6094,
    r: 12.5,
    fill: "#E0E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1953 9.60938V7.35938H10.1953V9.60938H8.69531V5.85938H17.6953V9.60938H16.1953ZM17.6953 12.9844C17.9078 12.9844 18.0859 12.9125 18.2297 12.7688C18.3734 12.625 18.4453 12.4469 18.4453 12.2344C18.4453 12.0219 18.3734 11.8438 18.2297 11.7C18.0859 11.5563 17.9078 11.4844 17.6953 11.4844C17.4828 11.4844 17.3047 11.5563 17.1609 11.7C17.0172 11.8438 16.9453 12.0219 16.9453 12.2344C16.9453 12.4469 17.0172 12.625 17.1609 12.7688C17.3047 12.9125 17.4828 12.9844 17.6953 12.9844ZM16.1953 17.8594V14.8594H10.1953V17.8594H16.1953ZM17.6953 19.3594H8.69531V16.3594H5.69531V11.8594C5.69531 11.2219 5.91406 10.6875 6.35156 10.2563C6.78906 9.825 7.32031 9.60938 7.94531 9.60938H18.4453C19.0828 9.60938 19.6172 9.825 20.0484 10.2563C20.4797 10.6875 20.6953 11.2219 20.6953 11.8594V16.3594H17.6953V19.3594ZM19.1953 14.8594V11.8594C19.1953 11.6469 19.1234 11.4688 18.9797 11.325C18.8359 11.1813 18.6578 11.1094 18.4453 11.1094H7.94531C7.73281 11.1094 7.55469 11.1813 7.41094 11.325C7.26719 11.4688 7.19531 11.6469 7.19531 11.8594V14.8594H8.69531V13.3594H17.6953V14.8594H19.1953Z",
    fill: "#3350EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.adae1a50a2f1260cd18ec50e631c1d8e.svg";
export { ForwardRef as ReactComponent };